import MarketingLayout from '../layouts/MarketingLayout.jsx'
import SEOHead from '../components/SEOHead.jsx'

export default function TermsPage() {
  return (
    <MarketingLayout>
      <SEOHead
        title="Conditions générales d'utilisation"
        description="Conditions générales d'utilisation de KartQuiz — acceptation, propriété intellectuelle, limitation de responsabilité."
        canonical="/cgu"
        robots="noindex, follow"
      />

      <section className="bg-[#F8FAFC] py-16">
        <div className="max-w-3xl mx-auto px-6">
          <h1 className="font-display font-semibold text-4xl text-kart-night mb-2">Conditions générales d'utilisation</h1>
          <p className="text-slate-400 text-sm">Dernière mise à jour : mai 2026</p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-6 prose prose-slate max-w-none">

          <p>
            Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation du service KartQuiz, édité par BCOMING.Digital (SIRET 877 976 571 00019), Lyon (69005), France.
          </p>

          <h2>1. Acceptation des CGU</h2>
          <p>
            La création d'un compte sur KartQuiz implique l'acceptation pleine et entière des présentes CGU. Si tu n'acceptes pas ces conditions, tu ne peux pas utiliser le service.
          </p>

          <h2>2. Description du service</h2>
          <p>
            KartQuiz est une plateforme en ligne de quiz interactifs gamifiés destinée aux enseignants, formateurs et animateurs. Le service permet de créer des quiz, de lancer des parties en ligne et d'en analyser les résultats pédagogiques. Le service est actuellement en <strong>bêta</strong> : des interruptions, modifications ou évolutions peuvent survenir sans préavis.
          </p>

          <h2>3. Création de compte</h2>
          <p>
            Seuls les enseignants, formateurs et animateurs peuvent créer un compte. En créant un compte, tu garantis fournir des informations exactes. Tu es responsable de la confidentialité de tes identifiants de connexion.
          </p>

          <h2>4. Propriété intellectuelle</h2>
          <p>
            Le code, le design, les textes, les visuels et les fonctionnalités de KartQuiz sont la propriété de BCOMING.Digital. Les quiz que tu crées restent ta propriété. En choisissant de partager un quiz dans la bibliothèque communauté, tu accordes à KartQuiz une licence non exclusive et gratuite pour l'afficher et le mettre à disposition d'autres utilisateurs.
          </p>

          <h2>5. Usage acceptable</h2>
          <p>Il est interdit d'utiliser KartQuiz pour :</p>
          <ul>
            <li>Créer ou diffuser des contenus offensants, discriminatoires, illégaux ou violents</li>
            <li>Tenter de contourner les mécanismes de sécurité du service</li>
            <li>Utiliser le service à des fins commerciales sans autorisation préalable</li>
            <li>Collecter des données personnelles d'autres utilisateurs</li>
          </ul>
          <p>
            BCOMING.Digital se réserve le droit de supprimer tout contenu non conforme et de suspendre les comptes en infraction, sans préavis.
          </p>

          <h2>6. Limitation de responsabilité (période bêta)</h2>
          <p>
            Pendant la période bêta, KartQuiz est fourni <em>« en l'état »</em>. BCOMING.Digital ne garantit pas la disponibilité continue du service ni l'absence de bugs. En aucun cas BCOMING.Digital ne pourra être tenu responsable de dommages directs ou indirects liés à l'utilisation ou à l'indisponibilité du service.
          </p>

          <h2>7. Résiliation</h2>
          <p>
            Tu peux demander la suppression de ton compte à tout moment en écrivant à <a href="mailto:contact@kartquiz.fr">contact@kartquiz.fr</a>. BCOMING.Digital se réserve le droit de résilier un compte en cas de violation des présentes CGU.
          </p>

          <h2>8. Modification des CGU</h2>
          <p>
            BCOMING.Digital peut modifier les présentes CGU à tout moment. Les utilisateurs seront notifiés par email en cas de modification substantielle. La poursuite de l'utilisation du service après notification vaut acceptation des nouvelles CGU.
          </p>

          <h2>9. Droit applicable</h2>
          <p>
            Les présentes CGU sont soumises au droit français. En cas de litige, les parties s'engagent à rechercher une solution amiable avant tout recours judiciaire. À défaut, les tribunaux compétents de Lyon seront saisis.
          </p>

          <h2>10. Contact</h2>
          <p>
            Pour toute question : <a href="mailto:contact@kartquiz.fr">contact@kartquiz.fr</a>
          </p>
        </div>
      </section>
    </MarketingLayout>
  )
}
